module.exports = __webpack_public_path__ + "img/raid44l.db946955.png";